module.exports = __webpack_public_path__ + "static/slide4-c655c42439a7eec99d5a82693be3e09a.jpg";